<template>
  <div class="w-[370px]">
    <div class="flex items-start space-x-3">
      <div class="inline-flex items-center space-x-2">
        <div class="w-24">
          <span v-html="$icons.stream"></span>
        </div>
        <p
          class="rounded px-2 py-1 text-xs font-medium"
          :class="
            account != 'DEMO'
              ? 'bg-ontick-blue-900 text-ontick-blue-500'
              : 'bg-gray-500 text-ontick-carbon-900 dark:text-gray-200'
          "
        >
          {{ account == "PRD" ? "P" : "D" }}
        </p>
      </div>
      <div>
        <!-- <div class="flex items-center space-x-2">
          <span v-html="icons" />
          <h2 class="font-bold dark:text-gray-200 text-ontick-carbon-900">{{ id }}</h2>
        </div> -->
        <h1
          class="text-sm font-semibold text-ontick-carbon-900 dark:text-gray-200"
        >
          {{ broker }}
        </h1>
        <h1
          class="text-sm font-semibold text-ontick-carbon-900 dark:text-gray-200"
        >
          {{ title }}
        </h1>
        <p
          class="mt-1 truncate text-xs text-ontick-steel-600 dark:text-gray-400"
        >
          {{ message }}
        </p>
        <p
          class="py-1 text-xs font-medium text-ontick-steel-600 dark:text-gray-400"
        >
          {{ timestamp | moment("DD/MM/YYYY HH:mm:ss:SSS") }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "topic",
    "color",
    "message",
    "title",
    "timestamp",
    "account",
    "broker",
  ],
};
</script>
